/*
 * @Author: zhushitao
 * @Date: 2021-03-10 14:47:04
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-08-02 10:58:14
 * @Description:
 */
export enum Lifecycle {
  /** 获取token和鉴权逻辑放到这里 最先执行的逻辑 这个hook之后一定能拿到鉴权信息 */
  APP_WILL_MOUNT = 'appWillMount',
  /** 目前只是个创建会话的状态 */
  CREATE_DIALOG_ING = 'createDialogIng',
  CREATE_DIALOG_SUCCESS = 'createDialogSuccess',
  /** 所有流程已完成 */
  APP_DID_MOUNT = 'appDidMount',
  APP_CONTEXT_CHANGE = 'appContextChange',
  /** 通道初始化之前 创建会话之后 */
  CHANNEL_WILL_MOUNT = 'channelWillMount',
  /** 通道初始化完成之后 创建会话之后 */
  CHANNEL_DID_MOUNT = 'channelDidMount',
  MESSAGE_CHANGE = 'messageChange',
  DIALOG_CHANGE = 'dialogChange',
  MESSAGES_CHANGE = 'messagesChange',
  APP_DESTROY = 'appDestroy',
  APP_ON_ERROR = 'appError',
}
